import { useTranslation } from 'react-i18next'

/**
 * What a form shows when its save was refused because the record moved underneath it
 * (`record_changed_elsewhere`).
 *
 * Never "reload the page": these forms share their page with panels — papers, the
 * federal register, the agents — and a reload would throw away everything typed there
 * too. What was typed stays on screen, on the version it was opened on, so a second
 * click cannot undo the other save either; loading what is saved is a deliberate step.
 *
 * `disabled` is for a form that runs one action at a time: while it saves or cancels,
 * a read landing after that answer would put an older record back on screen.
 */
export function ChangedElsewhereNotice({
  onLoadSaved,
  isLoading,
  disabled = false,
}: {
  onLoadSaved: () => void
  isLoading: boolean
  disabled?: boolean
}) {
  const { t } = useTranslation()

  return (
    <div className="alert changed-elsewhere" role="alert">
      <p>{t('records.changedElsewhere')}</p>
      <button
        type="button"
        className="button button--quiet"
        onClick={onLoadSaved}
        disabled={isLoading || disabled}
      >
        {isLoading ? t('records.loadingSaved') : t('records.loadSaved')}
      </button>
    </div>
  )
}
